export const GENERIC_ERROR = 'Connectivity issue';

export const INSURANCE_EXPIRATION_WARNING = 'Because your insurance is about to expire you must contact your rep to book loads';

export const LANDING_TITLE = 'ARRIVEnow Carrier';
export const FIND_LOADS_TITLE = 'Find Loads | ARRIVEnow Carrier';
export const MY_LOADS_TITLE = 'My Loads | ARRIVEnow Carrier';
export const loadDetailsTitle = (origin: string, dest: string, loadNumber: number) => `${origin} - ${dest} | Load #${loadNumber}`;
export const MY_OFFERS_TITLE = 'My Offers | ARRIVEnow Carrier';
export const MY_COMPANY_TITLE = 'My Company | ARRIVEnow Carrier';
export const MY_PROFILE_TITLE = 'My Profile | ARRIVEnow Carrier';
export const CONTACT_TITLE = 'Contact Us | ARRIVEnow Carrier';
export const COMMITTED_CAPACITY_TITLE = 'Committed Capacity | ARRIVEnow Carrier';
